module.exports = __webpack_public_path__ + "64c46f7e.svg";